import { render } from "./SelectInput.vue?vue&type=template&id=5a573d72&scoped=true&ts=true"
import script from "./SelectInput.vue?vue&type=script&lang=ts"
export * from "./SelectInput.vue?vue&type=script&lang=ts"

import "./SelectInput.vue?vue&type=style&index=0&id=5a573d72&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a573d72"]])

export default __exports__